import { render, staticRenderFns } from "./editAlarm.vue?vue&type=template&id=674344fc&scoped=true&"
import script from "./editAlarm.vue?vue&type=script&lang=js&"
export * from "./editAlarm.vue?vue&type=script&lang=js&"
import style0 from "./editAlarm.vue?vue&type=style&index=0&id=674344fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674344fc",
  null
  
)

export default component.exports